// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
  },
})
export class MultiColumnTextAndImageModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get headlineTheme() {
    return this.backgroundColor == "black" ? "secondary" : "default";
  }

  get showHeadlines() {
    let columns = this.instance["columns"];

    let result = false;
    columns.forEach((column) => {
      if (column.headline.length > 0) {
        result = true;
      }
    });

    return result;
  }

  get gridColmuns() {
    let len = this.instance["columns"].length;

    return len % 3 == 0 ? 4 : 6;
  }

  public buttonTheme(column) {
    switch (column["button"]["button_type"]) {
      case "wb-e-btn-1":
        return "primary";
      case "wb-e-btn-2":
        return "default";
      case "wb-e-btn-3":
        return "inverted";
      case "button_outline":
        return "outline-secondary";
      default:
        return "default";
    }
  }

  public isVideo(column) {
    return (
      column["videolink"] &&
      column["videolink"] != "" &&
      (column["videolink"]["embedUrl"] || column["videolink"]["uploadUrl"])
    );
  }

  public isImage(imageObject) {
    return this.getTranslatedImage(imageObject, this.lang, "full");
  }

  public columnImages(column) {
    if (column["images"]) {
      return column["images"].slice();
    } else {
      return [];
    }
  }

  downloadLink(download) {
    if (
      download.doc !== "" &&
      this.getTranslatedImage(download.doc, this.lang, "full")
    ) {
      return this.getTranslatedImage(download.doc, this.lang, "full");
    } else {
      return download.link;
    }
  }

  stats(download) {
    let stat = "";

    if (
      typeof download.doc === "object" &&
      download.doc[this.lang] !== null &&
      Array.isArray(download.doc[this.lang]) &&
      (download.doc[this.lang] as any).length > 0
    ) {
      if (download.doc[this.lang] && download.doc[this.lang].file_type !== "")
        stat +=
          download.doc[this.lang].file_type +
          (download.doc[this.lang].file_size !== "" ? ", " : "");

      if (download.doc[this.lang] && download.doc[this.lang].file_size !== "")
        stat += download.doc[this.lang].file_size;
    } else {
      if (download.doctype !== "") {
        stat += download.doctype + (download.docsize !== "" ? ", " : "");
      }

      if (download.docsize !== "") {
        stat += download.docsize;
      }
    }
    return stat;
  }
}
